var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 5.956A5.956 5.956 0 015.956 0h11.912a5.956 5.956 0 015.956 5.956v11.913a5.956 5.956 0 01-5.956 5.956H5.956A5.956 5.956 0 010 17.869V5.956zm12.478 2.428a3.515 3.515 0 10-1.031 6.953 3.515 3.515 0 001.03-6.953zm-5.888.772a6.015 6.015 0 1110.745 5.408A6.015 6.015 0 016.59 9.156zM18.463 2.98a1.191 1.191 0 100 2.382 1.191 1.191 0 000-2.382z","fill":"#fff"}));
}

Instagram.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = Instagram;

Instagram.default = Instagram;
